import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCFLNChildrenAskingQuestionsDuringActivity = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children asking questions during activity (%)" />
    </Box>
  );
};
